module.exports = __webpack_public_path__ + "img/car.6de52331.jpg";